import {
    useContext,
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITraceContentProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useTraceCollapsibleContext,
    TraceContext
} from "../../context";
import CollapseRegion from "../../../collapsible/internal/collapseRegion";

const TraceContent: FC<ITraceContentProps> = ({
    customTheme: customThemeProp,
    contentContainerStyle,
    isGuideHidden = false,
    isKeepMounted = false,
    children,
    style,
    ...props
}) => {
    const traceContext = useContext(TraceContext);

    const context = useTraceCollapsibleContext({
        part: "Content"
    });

    const customTheme = customThemeProp ?? traceContext?.customTheme;

    const {
        iconSizes,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        content: contentDynamicStyle,
        guide: guideDynamicStyle
    } = useStyles({
        iconSizes,
        borders,
        colors,
        spaces
    });

    if(!context) {
        return null;
    }

    return <CollapseRegion
        {...props}
        aria-labelledby={context.triggerID}
        isKeepMounted={isKeepMounted}
        contentStyle={[
            contentContainerStyle,
            stylesheet.content,
            contentDynamicStyle
        ]}
        customTheme={customTheme}
        style={[
            style,
            stylesheet.container
        ]}
        isOpen={context.isOpen}
        id={context.contentID}
    >
        {
            isGuideHidden ?
                null
            :
                <View
                    style={[
                        stylesheet.guide,
                        guideDynamicStyle
                    ]}
                    aria-hidden={true}
                />
        }
        {children}
    </CollapseRegion>;
};
export default TraceContent;
